var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2691 9.129L5.13941 1.63681C4.86258 1.48174 4.5451 1.41462 4.22919 1.44439C3.91329 1.47416 3.61394 1.59941 3.37095 1.80346C3.12797 2.00752 2.95287 2.28072 2.86894 2.58672C2.78501 2.89273 2.79624 3.21703 2.90113 3.51649L5.25894 10.4977L2.90113 17.479C2.81823 17.7145 2.79299 17.9665 2.8275 18.2138C2.86202 18.461 2.95529 18.6964 3.09951 18.9003C3.24373 19.1041 3.43469 19.2704 3.6564 19.3852C3.8781 19.5 4.1241 19.5601 4.37378 19.5602C4.64228 19.5597 4.90615 19.4903 5.14019 19.3587L5.14722 19.354L18.2722 11.8485C18.5129 11.7123 18.7131 11.5147 18.8523 11.2758C18.9916 11.0369 19.065 10.7653 19.065 10.4888C19.065 10.2122 18.9916 9.94065 18.8523 9.70176C18.7131 9.46287 18.5129 9.26522 18.2722 9.129H18.2691ZM4.9355 17.3149L6.92144 11.4352H11.2488C11.4974 11.4352 11.7359 11.3365 11.9117 11.1607C12.0875 10.9848 12.1863 10.7464 12.1863 10.4977C12.1863 10.2491 12.0875 10.0106 11.9117 9.83483C11.7359 9.65902 11.4974 9.56025 11.2488 9.56025H6.92144L4.93472 3.67899L16.8691 10.4892L4.9355 17.3149Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendArrow);
export default __webpack_public_path__ + "static/media/sendArrow.ba955e79340568ec87980ff1de9d446a.svg";
export { ForwardRef as ReactComponent };